import React from 'react';
import './css/common.css';
import useCheckVersion from './useCheckVersion'; // Adjust the import path as needed
import RefreshSidebar from './RefreshSidebar';
import axios from 'axios';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RouterPage from './RouterPage';

function App() {


  const admin_id = sessionStorage.getItem('admin_id');
  const token = sessionStorage.getItem('token');
  const isLoggedIn = !!(token || admin_id); // ✅ Force boolean

  console.log('isLoggedIn', isLoggedIn);


  // ✅ Always call hook (React rule), but we’ll only *use* it when logged in
  const isNewVersion = useCheckVersion(isLoggedIn);

  const handleRefresh = () => {
    const admin_id = sessionStorage.getItem('admin_id');

    localStorage.clear();
    sessionStorage.clear();
    // Clear cache
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    axios.get('/version.json')
      .then(response => {

        if (response.data.version) {
          if (admin_id) {
            window.location.href = '/ulogin';
          } else {
            window.location.href = '/sign-in';
          }
        }

      })
      .catch(error => {
        console.error(error);
      });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="App">
        {isLoggedIn && isNewVersion && (
          <RefreshSidebar isNewVersion={true} onRefresh={handleRefresh} />
        )}
        <RouterPage />
      </div>
    </React.Fragment>
  );
}

export default App;
